import { Component, OnInit, OnDestroy, Input, Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { NotificationInterface } from '@core/store/models/notifications.interface';

import { NotificationsService } from '@core/services/notifications/notifications.service';


@Component({
    selector: 'core-notifications-helpers-event-version-status-update-failed',
    templateUrl: './version-status-update-failed.component.html',
    styleUrls: ['./version-status-update-failed.component.scss']
})
export class CoreNotificationsHelpersEventVersionStatusUpdateFailedComponent implements OnInit, OnChanges {

    // EVENT_VERSION_STATUS_UPDATED_FAILED
    @Input() notification: NotificationInterface;

    constructor(private notsSrv: NotificationsService) {
    }

    ngOnInit(){
        console.log(" notification version failed item ",this.notification)
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(changes.notification){
        console.log(" notification was updated ",this.notification)

      }
    }

    dismiss():void {
        this.notsSrv.dismissNotification(this.notification.id);
    }

}
